import { PromotionCampaignStatusEnum } from "./status-enum";

export const promotionCampaignStatusColors = Object.freeze({
  [PromotionCampaignStatusEnum.DRAFT]: "default",
  [PromotionCampaignStatusEnum.ACTIVE]: "success",
  [PromotionCampaignStatusEnum.PAUSED]: "warning",
  [PromotionCampaignStatusEnum.DEPLETED]: "error",
  [PromotionCampaignStatusEnum.EXPIRED]: "error",
});
